/* eslint-disable no-useless-escape */
/* eslint-disable no-plusplus */
import { useRef, useState } from 'react';

import Papa from 'papaparse';
import { useDropzone } from 'react-dropzone';

import { PrimaryButton } from '@/components/Button/PrimaryButton';
import useMediaQuery from '@/hooks/useMediaQuery';
import { sendNotifcation } from '@/utils/notification';

function TokenCreationStep2({
  setStep1Complete,
  setFile,
  addresses,
  setAddresses,
  handleUpload,
  isLoading,
}: {
  setStep1Complete: Function;
  file: File;
  setFile: Function;
  addresses: string;
  setAddresses: Function;
  handleUpload: Function;
  isLoading: boolean;
}) {
  const hiddenFileInput = useRef(null);
  const textArea = useRef(null);
  const isMedia1025px = useMediaQuery('(max-width : 1025px)');
  const [csvAddresses, setCsvAddresses] = useState([]);
  const [textAreaFocused, setTextAreaFocused] = useState(false);

  const handleSelectFile = (newFile: File) => {
    if (newFile?.type !== 'text/csv') {
      setFile(null);
      sendNotifcation('Only CSV files are allowed', '', 'danger');
      return;
    }
    setFile(newFile);
    Papa.parse(newFile, {
      complete: (result) => {
        const x = result.data.filter((e: any) => {
          return e[0].substring(0, 2) === '0x' || e[0].includes('.eth');
        });
        setAddresses('');
        setCsvAddresses(x.map((address: any) => address[0]));
      },
    });
  };

  const selectFile = (acceptedFiles: FileList) => {
    const newFile = Array.from(acceptedFiles)[0];
    handleSelectFile(newFile);
  };

  const handleDrop = (acceptedFiles: File[]) => {
    const newFile = acceptedFiles[0];
    handleSelectFile(newFile);
  };

  const onSelectClick = () => {
    if (isLoading) return;
    hiddenFileInput.current.click();
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    accept: 'text/csv',
    maxSize: 3072000,
    maxFiles: 1,
    noClick: true,
  });
  const textAreaCheck = () => {
    if (addresses === '' && csvAddresses.length >= 1) {
      return true;
    }
    const addressList = addresses.split(',');
    for (let i = 0; i < addressList.length; i++) {
      const addressWithoutSpaces = addressList[i].replace(/\s/g, '');
      const x = /[`!@#$%^&*.()_+\-=\[\]{};':"\\|,<>\/?~]/.test(
        addressWithoutSpaces.substring(0, 1)
      );
      const y = addressWithoutSpaces.indexOf('.');
      if (
        !(
          (addressWithoutSpaces.substring(y, addressWithoutSpaces.length) ===
            '.eth' &&
            !x) ||
          (addressWithoutSpaces.length === 42 &&
            addressWithoutSpaces.substring(0, 2) === '0x')
        )
      ) {
        return false;
      }
    }
    return true;
  };

  return (
    <div className="flex p-2  flex-col items-center h-full">
      <>
        <div className="h-full pb-4 w-full">
          {csvAddresses.length >= 1 ? (
            <div
              className={`${
                isMedia1025px ? 'h-72' : 'h-full'
              } w-full overflow-scroll p-4 border-2 break-words rounded-md border-black`}
            >
              {csvAddresses.map((address, index) => (
                <p
                  key={index}
                  className="flex border-b-2 p-2 overflow-scroll no-scrollbar w-full"
                >
                  {address}
                </p>
              ))}
            </div>
          ) : (
            <div {...getRootProps()} className="mt-4 h-full w-full">
              {isDragActive && textArea.current.focus()}
              <textarea
                onFocus={() => setTextAreaFocused(true)}
                onBlur={() => setTextAreaFocused(false)}
                onChange={(e) => setAddresses(e.target.value)}
                ref={textArea}
                className={`w-full rounded-md mb-2 ${
                  isMedia1025px ? 'h-40' : 'h-[95%]'
                } ${
                  !textAreaCheck() && textAreaFocused
                    ? 'border border-red focus:outline-none'
                    : ''
                } p-4`}
                placeholder={`${
                  isDragActive
                    ? 'Drop it here'
                    : `${
                        isMedia1025px
                          ? 'Paste list of Addresses separate by a comma each '
                          : 'Drop CSV file or paste a list of addresses'
                      }`
                }`}
              />
              <input {...getInputProps()} />
              {isMedia1025px && (
                <>
                  <div>OR</div>
                  <div className="mt-2  w-full flex justify-center items-center">
                    <input
                      multiple={true}
                      type={'file'}
                      ref={hiddenFileInput}
                      accept="text/csv"
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        selectFile(e.target.files);
                        e.target.value = null;
                      }}
                    />
                    <button
                      onClick={onSelectClick}
                      className="bg-black px-6 py-2 rounded-md text-white"
                    >
                      <span>Select CSV File</span>
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        <div className=" flex w-full">
          <PrimaryButton
            onClick={() => {
              if (csvAddresses.length > 0) {
                setFile(null);
                setCsvAddresses([]);
              } else {
                setStep1Complete(false);
              }
            }}
          >
            <span>Back</span>
          </PrimaryButton>
          <div className="w-full justify-end flex">
            <PrimaryButton
              disabled={!textAreaCheck()}
              onClick={() => handleUpload()}
              isLoading={isLoading}
            >
              <span>Next</span>
            </PrimaryButton>
          </div>
        </div>
      </>
    </div>
  );
}
export default TokenCreationStep2;
